import colors from "../../../styles/colors/colors";

export const OuterGrid = () => ({
    backgroundColor: colors.white[1],
    opacity: 1,
    padding: "1rem 1rem",
    borderRadius: "0.8rem",
  });